var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4168_895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5431 0.444336C34.6367 0.444336 35.6856 0.87877 36.4589 1.65207C37.2322 2.42537 37.6666 3.47418 37.6666 4.56779V33.432C37.6666 34.5256 37.2322 35.5744 36.4589 36.3477C35.6856 37.121 34.6367 37.5554 33.5431 37.5554H4.67894C3.58533 37.5554 2.53651 37.121 1.76321 36.3477C0.989915 35.5744 0.555481 34.5256 0.555481 33.432V4.56779C0.555481 3.47418 0.989915 2.42537 1.76321 1.65207C2.53651 0.87877 3.58533 0.444336 4.67894 0.444336H33.5431ZM32.5123 32.4011V21.474C32.5123 19.6914 31.8041 17.9818 30.5437 16.7213C29.2832 15.4609 27.5736 14.7527 25.791 14.7527C24.0386 14.7527 21.9975 15.8248 21.0078 17.433V15.1445H15.2556V32.4011H21.0078V22.2368C21.0078 20.6493 22.2861 19.3504 23.8736 19.3504C24.6392 19.3504 25.3733 19.6545 25.9146 20.1958C26.4559 20.7371 26.76 21.4713 26.76 22.2368V32.4011H32.5123ZM8.55499 11.9075C9.47362 11.9075 10.3546 11.5426 11.0042 10.8931C11.6538 10.2435 12.0187 9.36247 12.0187 8.44384C12.0187 6.52644 10.4724 4.95952 8.55499 4.95952C7.63089 4.95952 6.74464 5.32662 6.0912 5.98006C5.43776 6.63349 5.07067 7.51974 5.07067 8.44384C5.07067 10.3613 6.63758 11.9075 8.55499 11.9075ZM11.4208 32.4011V15.1445H5.7098V32.4011H11.4208Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4168_895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.1111,
    height: 37.1111,
    fill: "white",
    transform: "translate(0.111084)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.b3a3280cf5754281847e42e3c7478a97.svg";
export { ForwardRef as ReactComponent };